import { PlanTier } from '../isTierFree';

export type AccountPlanTier = [number, number];
export type TrialType = 'Professional' | 'Team' | 'Company';
export type PlanType = 'Free' | 'Starter' | TrialType;
export type Interval = 'month' | 'year';

export type PlanIntervalProps = {
  __typename?: 'PlanIntervalProps';
  amount: number;
  id: number;
  interval: Interval;
  monthlyAmount: number;
};

export type TaskLimitVariant = {
  __typename?: 'TaskLimitVariant';
  intervals: Array<PlanIntervalProps>;
  name: string;
  tasks: number;
};

export type PlanLimits = {
  premium_apps_limit: number;
  zap_limit: number;
  action_limit: number;
};

export type AccountPlan = {
  __typename?: string;
  actions: number;
  allow_branching_zaps: boolean;
  allow_companies: boolean;
  allow_premium_apps: boolean;
  allow_teams: boolean;
  apps: number;
  authentications: number;
  can_autoreplay_errored_tasks: boolean;
  intervals: Array<PlanIntervalProps>;
  limits: PlanLimits;
  max_metering_charge: number;
  meta: Array<any>;
  metered_pricing_tiers?: Array<AccountPlanTier>;
  metered_task_pricing: boolean;
  min_seats: number;
  name: string;
  off_plan_group?: boolean;
  per_extra_action?: number;
  plan_type: PlanType;
  polling_interval_minutes: number;
  trial_period_days?: number;
  task_limit_variants: Array<TaskLimitVariant>;
  type: string;
  zap_length: number;
  zaps: number;
};

export const formatPlanTiers = (plan: AccountPlan): PlanTier[] =>
  plan?.metered_pricing_tiers?.map(
    ([numTasks, pricePerTask]: AccountPlanTier) => ({
      numTasks,
      pricePerTask,
    })
  ) ?? [];
